import { ref, computed } from "vue"
import {
  startOfMonth,
  endOfMonth,
  subMonths,
  addMonths,
  format,
} from "date-fns"
import { nl } from "date-fns/locale"
import { HISTORY_MONTHS_BACK } from "@/helpers/energyBillConstants.js"

/**
 * Month-level period navigation: prev/next month within a rolling
 * `HISTORY_MONTHS_BACK` window ending at the current month.
 */
export default function useMonthNavigation() {
  const selectedMonth = ref(startOfMonth(new Date()))

  const canGoPrev = computed(
    () =>
      selectedMonth.value >
      subMonths(startOfMonth(new Date()), HISTORY_MONTHS_BACK),
  )
  const canGoNext = computed(
    () => selectedMonth.value < startOfMonth(new Date()),
  )

  function prevMonth() {
    if (canGoPrev.value) {
      selectedMonth.value = subMonths(selectedMonth.value, 1)
    }
  }
  function nextMonth() {
    if (canGoNext.value) {
      selectedMonth.value = addMonths(selectedMonth.value, 1)
    }
  }

  const monthLabel = computed(() =>
    format(selectedMonth.value, "MMMM yyyy", { locale: nl }),
  )

  const monthDateRange = computed(() => [
    startOfMonth(selectedMonth.value),
    endOfMonth(selectedMonth.value),
  ])

  return {
    selectedMonth,
    monthLabel,
    monthDateRange,
    canGoPrev,
    canGoNext,
    prevMonth,
    nextMonth,
  }
}
